export function hideFeature(listToHide: string[], feature: string, hostToCheck?: string) {
  if (!listToHide) return false;
  if (!hostToCheck) return listToHide?.includes(feature);

  const { host } = window.location;
  return host?.includes(hostToCheck) ? listToHide?.includes(feature) : false;
}
